import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=c5a80d9a&scoped=true&"
import script from "./FieldText.vue?vue&type=script&lang=js&"
export * from "./FieldText.vue?vue&type=script&lang=js&"
import style0 from "./FieldText.vue?vue&type=style&index=0&id=c5a80d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a80d9a",
  null
  
)

export default component.exports